// src/components/AuthRedirect.tsx
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AuthRedirect() {
  const { profile, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if still loading or not authenticated
    if (loading) return;
    if (!isAuthenticated) return;
    if (!profile) return;

    const currentPath = location.pathname;

    // Skip redirect if user is already on their correct dashboard
    if (profile.role === "admin" && currentPath.startsWith("/admin")) {
      return;
    }
    if (profile.role === "broker" && currentPath.startsWith("/broker")) {
      return;
    }
    if (profile.role === "carrier" && currentPath.startsWith("/carrier")) {
      return;
    }

    // Only redirect from login or root
    if (currentPath !== "/login" && currentPath !== "/") {
      return;
    }

    // Perform redirect based on role
    if (profile.role === "admin") {
      navigate("/admin/dashboard", { replace: true });
    } else if (profile.role === "broker") {
      navigate("/broker/dashboard", { replace: true });
    } else {
      // Default: carrier
      navigate("/carrier/dashboard", { replace: true });
    }
  }, [loading, isAuthenticated, profile, navigate, location]);

  return null;
}